export enum PhoneTypes {
  Mobile = "celular",
  Oficina = "oficina",
  Home = "casa",
}
